<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-layout justify-center>
        <v-dialog v-model="show" width="700px">
            <template v-slot:activator="{ on }">

            </template>
            <v-card>
                <v-toolbar dark color="blue lighten-2">
                    <v-btn icon dark @click="show = false">
                        <v-icon>close</v-icon>
                    </v-btn>
                    <v-toolbar-title>Сообщение</v-toolbar-title>
                    <EventButtonsInFooter
                            :messageModel="messageModel"
                            @visKeyboardForm="visKeyboardForm=true"
                            @visAttachmentForm="visAttachmentForm=true"
                            @findWordBlock="messageModel.find_type = 1"
                            @moduleBlock="moduleBlock=!moduleBlock"
                            @chainBlock="messageModel.rnd = 1"
                    ></EventButtonsInFooter>
                    <v-spacer></v-spacer>
                    <v-toolbar-items>
                        <test-message-sender
                                :modelId="messageModel.id"
                                @testMessageSenderNotification="testMessageSenderNotification"
                        ></test-message-sender>
                        <v-btn dark text @click="saveValue" :disabled="!valid">
                            <v-icon>save</v-icon>
                            {{messageModel.id === null ? ' Создать' : '\t\t Сохранить'}}
                        </v-btn>
                    </v-toolbar-items>
                </v-toolbar>
                <v-list three-line subheader class="content">
                    <v-container>
                        <v-form
                                ref="form"
                                v-model="valid"
                        >
                            <v-row class="d-flex">
                                <v-col cols="12" md12 class="py-0">
                                    <v-text-field
                                            v-model="messageModel.title"
                                            :counter="35"
                                            label="Название сообщения"
                                            class="ma-2 pa-2"
                                            required
                                            :rules="[rules.required, rules.maxLengthTitle]"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" md12 class="py-0">
                                    <v-textarea
                                            v-show="!htmlEditor"
                                            auto-grow
                                            rows="5"
                                            name="input-7-1"
                                            v-model="messageModel.text"
                                            :counter="3000"
                                            label="Текст ответа"
                                            class="ma-2 pa-2 my-0 py-0"
                                            required
                                            :rules="[rules.maxLengthText]"
                                    >
                                    </v-textarea>
                                    <text-editor v-show="htmlEditor" :text="textInEditor"
                                                 @updateText="updateText"></text-editor>
                                    <v-switch v-model="htmlEditor" label="HTMLEditor for Telegram"></v-switch>
                                </v-col>
                                <v-col cols="12" md12 class="py-0 px-7">
                                    <media-library-block :attachments="attachments"/>
                                </v-col>
                                <v-col cols="12" md12 class="py-0 px-7">
                                    <MessageButtonViewer
                                            :edit="true"
                                            :modelKeyboardId="messageModel.keyboard_id"
                                    ></MessageButtonViewer>
                                </v-col>
                                <v-col cols="12" md12 class="py-0 px-7">
                                    <MessageFindWordBlock
                                            :messageModel="messageModel"
                                            :findWordBlock="findWordBlock"
                                            @saveMessage="saveValue"
                                    ></MessageFindWordBlock>
                                </v-col>
                                <v-col cols="12" md12 class="py-0 px-7">
                                    <MessageChainBlock
                                            :messageModel="messageModel"
                                            :chainBlock="chainBlock"
                                            @saveMessage="saveValue"
                                    ></MessageChainBlock>
                                </v-col>
                                <v-col cols="12" md12 class="py-0 px-7">
                                    <MessageModuleBlock
                                            :messageModel="messageModel"
                                            :moduleBlock="moduleBlock"
                                            :moduleGroups="moduleGroups"
                                            @saveMessage="saveValue"
                                            @hideBlock="moduleBlock=false"
                                            @showBlock="moduleBlock=true"
                                    ></MessageModuleBlock>
                                </v-col>
                                <v-col cols="12" md12 class="py-0 px-7">
                                    <MessageSettingBlock
                                            :messageModel="messageModel"
                                            @saveMessage="saveValue"
                                    ></MessageSettingBlock>
                                </v-col>
                            </v-row>

                        </v-form>
                    </v-container>
                </v-list>
            </v-card>
        </v-dialog>
        <KeyboardForm :visible="visKeyboardForm" :keyboards="keyboards" :keyboardId="messageModel.keyboard_id"
                      :messageModel="messageModel"
                      @close="visKeyboardForm=false"
                      @selectKeyboard="selectKeyboard"
                      @removeKeyboard="removeKeyboard"
        ></KeyboardForm>
        <media-library-select-box
                :visible="visAttachmentForm"
                :obj-type="2"
                :model="messageModel" @close="visAttachmentForm=false"
                @updateAttachment="updateAttachment"
        />
        <v-snackbar
                v-model="snackbarParams.show"
                bottom
                :color="snackbarParams.color"
                right
        >
            {{snackbarParams.text}}
            <v-btn
                    dark
                    text
                    @click="snackbarParams.show = false"
            >
                Закрыть
            </v-btn>
        </v-snackbar>
    </v-layout>

</template>

<script>
import KeyboardForm from '@/components/bot/message/KeyboardForm'
import MediaLibrarySelectBox from './MediaLibrarySelectBox'
import MediaLibraryBlock from './MediaLibraryBlock'
import MessageFindWordBlock from './MessageFindWordBlock'
import MessageChainBlock from './MessageChainBlock'
import MessageModuleBlock from './MessageModuleBlock'
import MessageSettingBlock from './MessageSettingBlock'
import EventButtonsInFooter from '../event/EventButtonsInFooter'
import MessageButtonViewer from './MessageButtonViewer'
import { mapGetters } from 'vuex'
import TextEditor from './TextEditor'
import TestMessageSender from './TestMessageSender'

export default {
    name: 'MessageForm',
    components: {
        KeyboardForm,
        MediaLibraryBlock,
        MessageFindWordBlock,
        MessageChainBlock,
        MessageModuleBlock,
        MessageSettingBlock,
        EventButtonsInFooter,
        MessageButtonViewer,
        TextEditor,
        TestMessageSender,
        MediaLibrarySelectBox
    },
    data() {
        return {
            show: false,
            snackbarParams: {
                show: false,
                text: 'Успешно сохранено',
                color: 'success'
            },
            visKeyboardForm: false,
            visAttachmentForm: false,
            attachments: [],
            moduleBlock: false,
            modules: [],
            moduleGroups: [],
            messageModel: {
                id: null
            },
            rules: {
                required: value => !!value || 'Обязательное поле.',
                maxLengthTitle: value => (value.length <= 35) || 'Максимальная длина названия 28 символов.',
                maxLengthText: value => (value === null || value.length <= 3000) || 'Максимальная длина сообщения 3000 символов.',
                maxLengthButton: value => (value.length <= 20) || 'Максимальная длина названия 20 символов.'
            },
            valid: false,
            messageModelDef: {
                id: null,
                title: 'Название сообщения',
                text: '',
                keyboard_id: null,
                name: null,
                type: null,
                result: null,
                attachment: null,
                parent: null,
                bot_id: null,
                questionnaire_id: null,
                action: null,
                private_answer: 1,
                next_message_id: null,
                words_to_find: null,
                chain: null,
                answer_title: null,
                location: null,
                equatio: null,
                erro: null,
                answer_title_id: null,
                module_group_id: null,
                type_w: null,
                sleep_type: 0,
                sleep_chain: 0,
                rnd: -1,
                priority: 0,
                find_type: 0,
                mailing_i: 0,
                hotkey: 0,
                dont_parse_links: 0,
                work: 1,
                created_at: null,
                message_list_id: null,
                counter: 0
            },
            textInEditor: '',
            textArea: true,
            htmlEditor: false
        }
    },
    props: ['editMessageId', 'dialog', 'messageListId'],
    methods: {
        saveValue: function () {
            // this.messageModel.text = //this.textInEditor.replace(/<br>/g, '\n').replace(/&nbsp;/g, ' ')
            this.$store.dispatch('messages/saveMessage', {
                model: this.messageModel,
                messageListId: this.messageListId
            }).then(response => {
                if (this.messageModel.id == null) {
                    this.$emit('addMessageToMessageList', { message: response, messageListId: this.messageListId })
                } else {
                    this.$emit('updateMessage', { messageModel: response, messageListId: this.messageListId })
                }
                this.messageModel = response
                this.snackbarParams.color = 'success'
                this.snackbarParams.text = 'Успешно сохранено!'
                this.snackbarParams.show = true
            })
        },
        selectKeyboard(id) {
            this.messageModel.keyboard_id = id === 0 ? null : id
            this.saveValue()
        },
        removeKeyboard(index) {
            if (this.messageModel.keyboard_id === this.keyboards[index].id) {
                this.messageModel.keyboard_id = null
                this.saveValue()
            }
        },
        updateAttachment(data) {
            this.attachments = data.selectedItems
        },
        loadModel(messageId) {
            if (messageId === null) {
                this.messageModel = Object.assign({}, this.messageModelDef)
            } else {
                this.messageModel = this._.cloneDeep(this.getMessageById(messageId))
                this.textInEditor = this.messageModel.text.replace(/\n/g, '<br>')// .replace(/&nbsp;/g, '\n')
            }
        },
        updateText(text) {
            this.messageModel.text = text
        },
        testMessageSenderNotification({ color, text }) {
            this.snackbarParams.color = color
            this.snackbarParams.text = text
            this.snackbarParams.show = true
        }
    },
    filters: {
        truncate(text, length, suffix) {
            if (text.length > length) {
                return text.substring(0, length) + suffix
            } else {
                return text
            }
        }
    },
    computed: {
        ...mapGetters({
            getKeyboardById: 'keyboards/getKeyboardById',
            keyboards: 'keyboards/keyboards',
            getKeyboardIndexById: 'keyboards/getKeyboardIndexById',
            messages: 'messages/messages',
            messagesLoaded: 'messages/getLoadedStatus',
            getMessageById: 'messages/getMessageById'
        }),
        chainBlock() {
            return this.messageModel.rnd !== -1
        },
        findWordBlock() {
            return this.messageModel.find_type !== 0
        }
    },
    watch: {
        htmlEditor(value) {
            if (value) {
                this.textInEditor = this.messageModel.text.replace(/\n/g, '<br>')
            }
        },
        dialog() {
            this.dialog === true ? this.show = true : this.show = false
        },
        show() {
            if (this.show === false) {
                this.messageModel = Object.assign({}, this.messageModelDef)
                this.$refs.form.resetValidation()
                this.textInEditor = ' '
                this.$emit('close')
                this.attachments = []
            } else {
                this.textInEditor = ' '
                this.loadModel(this.editMessageId)
            }
        },
        'messageModel.text': {
            handler() {
                if (!this.textArea) { this.textInEditor = this.messageModel.text.replace(/\n/g, '<br>') }
            },
            deep: true
        }
    },
    created() {
        this.messageModelDef.bot_id = this.$route.params['pathMatch']
        this.$store.dispatch('messages/changeBotIdModelDefault', this.$route.params['pathMatch'])
    }
}
</script>

<style scoped lang="scss">
    ::-webkit-scrollbar {
        width: $width-scroll-panel;
    }

    /* Track */
    ::-webkit-scrollbar-track {
        background: $light;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
        background: $blue-active;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
        background: $blue-inactive;
    }

    .container {
        height: 70vh;
        display: flex;
        flex-direction: column;
    }
</style>
